/* src/app/shared/ui/components/inputs/range-calendar/range-calendar.component.scss */
.custom-calendar-body-selected .mat-calendar-body-cell-content,
.custom-calendar-body-selected {
  background-color: #607bee;
  color: #ffffff;
}
.custom-calendar-body-selected .mat-calendar-body-today,
.mat-calendar-table .mat-calendar-body-in-range .mat-calendar-body-today {
  background-color: #607bee !important;
  color: #ffffff !important;
  font-weight: normal !important;
  box-shadow: inset 0 0 0 1px var(--mat-datepicker-calendar-date-today-selected-state-outline-color);
}
.mat-calendar {
  width: 100%;
  margin-inline: auto;
  border-radius: 1rem;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15), 0 0 2px 0 rgba(0, 0, 0, 0.05);
}
.mat-calendar-table-header tr:first-child th {
  font-size: 1.4rem;
}
.mat-calendar-table .mat-calendar-body {
  font-size: 1.4rem;
}
.mat-calendar-table .mat-calendar-body-in-range .mat-calendar-body-cell-content {
  color: #ffffff !important;
}
.mat-calendar-table .mat-calendar-body-in-range::before {
  background-color: #607bee;
}
.mat-calendar-table .mat-calendar-body-selected {
  background-color: #607bee;
}
.mat-calendar-table .mat-calendar-body-today:not(.mat-calendar-body-selected) {
  border-color: rgba(255, 0, 0, 0);
  background: #d1dcff;
  color: #515258;
  font-weight: bold;
}
/*# sourceMappingURL=range-calendar.component.css.map */
